import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError, apiLimit } from "../../utils/api.types";

import {
    Inventories,
    InventoryFormInputs,
    InventoryResponse,
    Inventory,
    InventoryUpdatePayload,
    InventoryAccountResponse,
    IItemCategory,
    IItemMeasuringUnit,
    InventoryNewFormInputs,
    InventoryFetch,
    AdjustStockHistoryPayload,
    IItemSubCategory,
} from "../../utils/inventory.types";

//Add Inventory async Thunk.
 export const addInventory = createAsyncThunk(
  'inventory/addInventory',
  async (inventoryPayload: InventoryNewFormInputs): Promise<InventoryResponse> => {
      const response = await axios.post(`/api/v1/sku`, inventoryPayload);

      return response.data
  }
);


/**
 * Fetch Inventories async thunk.
*/
export const fetchInventories = createAsyncThunk(
    'inventory/fetchInventories',
    async ({accountId, type, params} : InventoryFetch): Promise<Inventories> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/sku/account/${accountId}?${queryParam}`);

        return response.data;
    }
);

export const selectedInventoryID = createAction("inventory/selectedInventoryID", (inventoryId) => {
    return {
        type: 'inventory/selectedInventoryID',
        payload: inventoryId
    }
});


/**
 * Update Inventories async Thunk.
 */
export const updateInventory = createAsyncThunk<
    InventoryResponse,
    InventoryUpdatePayload,
    {
        rejectValue: IError,
    }
>(
    'inventory/updateInventory',
    async ({ id, inventoryPayload }: InventoryUpdatePayload, thunkApi) => {
        try {
            const response = await axios.put(`/api/v1/sku/${id}`, inventoryPayload);

            const { data } = response;

            if (response.status === 200) {
                return data;
            }

            return thunkApi.rejectWithValue(data.error);
        } catch (error: any) {
            return thunkApi.rejectWithValue(error.response.data);
        }
    }
);


/**
 * Fetch Inventies async thunk.
*/
export const fetchInventoryByAccountId = createAsyncThunk(
    'inventory/fetchInventoryByAccountId',
    async (id: string): Promise<Inventory> => {
        const response = await axios.get(`/api/v1/sku/account/${id}`);
        return response.data;
    }
);

/**
 * Fetch Inventory By UD async thunk.
*/

export const fetchInventoryById = createAsyncThunk(
    'inventory/fetchInventoryById',
    async (id: string): Promise<Inventory> => {
        const response = await axios.get(`/api/v1/sku/${id}`);
        return response.data;
    }
);

/**
 * Delete Inventories async Thunk.
 */
export const deleteInventory = createAsyncThunk(
    'inventory/deleteInventory',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/sku/${id}`);

        response.data['id'] = id;

        return response.data
    }
);


// Fetch skus by name async Thunk.
export const fetchAccountSkuByName  = createAsyncThunk(
    'sku/search',
    async (queryString: string): Promise<InventoryAccountResponse> => {
        const response = await axios.get(`/api/v1/sku/new/search?${queryString}`);
        return response.data;
    }
);


export const fetchItemCategories = createAsyncThunk(
    'gst/fetchItemCategories',
    async (): Promise<IItemCategory[]> => {
        const response = await axios.get(`/api/v1/sku/category/get`);
        console.log(response)
        return response.data;
    }
);

export const fetchItemSubCategories = createAsyncThunk(
    'gst/fetchItemSubCategories',
    async (categoryId: string): Promise<IItemCategory[]> => {
        const response = await axios.get(`/api/v1/sku/sub-category/get?categoryId=${categoryId}`);
        return response.data;
    }
);

export const fetchMeasuringUnits = createAsyncThunk(
    'gst/fetchMeasuringUnits',
    async (): Promise<IItemMeasuringUnit[]> => {
        const response = await axios.get(`/api/v1/sku/measuring-unit/get`);
        return response.data.measuringUnits;
    }
);

export const fetchSkuHistoryBySkuId = createAsyncThunk(
    'sku/fetchSkuHistory',
    async (skuId: string): Promise<any[]> => {
        const response = await axios.get(`/api/v1/sku/history/${skuId}`);
        return response.data;
    }
);

export const AdjustStockBySkuId = createAsyncThunk(
    'sku/AdjustStockBySkuId',
    async ({ skuId, stockHistoryPayload }: AdjustStockHistoryPayload, thunkApi) => {
        const response = await axios.post(`/api/v1/sku/history/${skuId}/adjust-stock`, stockHistoryPayload);
        return response.data;
    }
);


// Add Category
export const createItemCategory = createAsyncThunk(
    'inventory/createItemCategory',
    async (categoryPayload: { name: string; alias?: string }): Promise<IItemCategory> => {
        const response = await axios.post(`/api/v1/sku/category/create`, categoryPayload);
        return response.data;
    }
);

// Update Category  
export const updateItemCategory = createAsyncThunk(
    'inventory/updateItemCategory',
    async ({ id, categoryPayload }: { id: string; categoryPayload: { name: string; alias?: string } }): Promise<IItemCategory> => {
        const response = await axios.put(`/api/v1/sku/category/${id}`, categoryPayload);
        return response.data;
    }
);

// Create Sub Category
export const createItemSubCategory = createAsyncThunk(
    'inventory/createItemSubCategory',
    async (subCategoryPayload: { name: string; alias?: string; category: string }): Promise<IItemSubCategory> => {
        const response = await axios.post(`/api/v1/sku/sub-category/create`, subCategoryPayload);
        return response.data;
    }
);

// Update Sub Category  
export const updateItemSubCategory = createAsyncThunk(
    'inventory/updateItemSubCategory',
    async ({ id, subCategoryPayload }: { id: string; subCategoryPayload: { name: string; alias?: string; category: string } }): Promise<IItemSubCategory> => {
        const response = await axios.put(`/api/v1/sku/sub-category/${id}`, subCategoryPayload);
        return response.data;
    }
);

// Fetch Sub Categories by Category ID
export const fetchItemSubCategoriesByCategory = createAsyncThunk(
    'inventory/fetchItemSubCategoriesByCategory',
    async (categoryId: string): Promise<IItemSubCategory[]> => {
        const response = await axios.get(`/api/v1/sku/sub-category/get?categoryId=${categoryId}`);
        return response.data;
    }
);


